<template>
  <div style="height:100%">
    <el-form label-width="100px">
      <el-form-item label="发起人">
        <el-input v-model="person" style="width:250px"></el-input>
      </el-form-item>
      <el-form-item label="单号">
        <el-input v-model="salesOderNo" style="width:250px"></el-input>
      </el-form-item>
      <el-form-item label="金额">
        <el-input-number v-model="price" style="width: 250px;"></el-input-number>
      </el-form-item>
      <el-form-item label="审核类型">
        <el-select filterable v-model="ApproveTypeSettingId" placeholder="请选择审批类型" size="small" clearable
          style="width: 250px;">
          <el-option v-for="item in ApprovedTypeOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary">测试</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import * as ApproveTypeSettingController from "../controllers/system/ApproveTypeSettingController"

export default {
  name: "testapproved",
  components: {},
  data() {
    return {
      person: '',
      salesOderNo: '',
      price: 0,
      ApproveTypeSettingId: '',
      ApprovedTypeOptions: [],
    }
  },
  created() {
    this.getApprovedType()
    console.log(this.$store.state.biz_data.userInfo.user_roles_privileges.roles)
  },
  methods: {
    async getApprovedType() {
      let _result = await ApproveTypeSettingController.methods.getData({
        id: { ">": 0 },
      })
      if (_result && _result[0].length > 0) {
        let datas = _result[0]
        //this.typeList = datas
        _.each(datas, (t) => {
          this.ApprovedTypeOptions.push({
            value: t.id,
            label: t.DocumentType + " : " + t.description,
            ApproveLevel: t.ApproveLevel
          })
        })
      }
    },
  },
}
</script>

<style>
.hb_table_price_disctable_class1 {
  width: 100vw;
  font-size: 0.8rem;
  background-color: white;
  overflow-x: auto;
  /* min-width: 150rem; */
}
</style>
